import BillingsOrderRailyTaxiCreateParams, {
  BillingsOrderRailyTaxiCreateParamsBillingNode,
  BillingsOrderRailyTaxiCreateParamsBonusType,
  BillingsOrderRailyTaxiCreateParamsPenaltyType,
} from "../../../../../common/services/billings/order/raily-taxi/create/billings-order-raily-taxi-create-params";
import BillingsNode from "../../../common/types/billings-node";
import BillingFormData from "../types/billing-form.data";
import BonusType from "../types/bonus-type";
import PenaltyType from "../types/penalty-type";

const createBillingNode = (
  node: BillingsNode,
): BillingsOrderRailyTaxiCreateParamsBillingNode => {
  return {
    uuid: node.id,
    nodeUuid: node.nodeId,
    orderUuid: node.orderId ?? undefined,
    lat: node.lat,
    lon: node.lon,
    distance: node.distance,
    description: node.description,
    checkoutDate: node.checkoutDate ?? undefined,
    checkoutEventUuid: node.checkoutEventUuid ?? undefined,
    plannedDate: node.plannedDate ?? undefined,
    haltingTime: node.haltingTime,
    allowCharge: node.isHighwayAllowed,
    highwayCharge: node.highwayCharge,
    plannedDistance: node.plannedDistance,
    editableCoordinates: node.isEditable,
  };
};

const createBillingNodes = (
  nodes: BillingsNode[],
): BillingsOrderRailyTaxiCreateParamsBillingNode[] => {
  return nodes.map(createBillingNode);
};

const createBonusType = (
  bonusType: BonusType | undefined,
): BillingsOrderRailyTaxiCreateParamsBonusType | undefined => {
  switch (bonusType) {
    case BonusType.DISTANCE_RATE_CHANGED:
      return BillingsOrderRailyTaxiCreateParamsBonusType.DISTANCE_RATE_CHANGED;
    case BonusType.HALTING_RATE_CHANGED:
      return BillingsOrderRailyTaxiCreateParamsBonusType.HALTING_RATE_CHANGED;
    case BonusType.OTHER:
      return BillingsOrderRailyTaxiCreateParamsBonusType.OTHER;
    case BonusType.SHORT_ROUTE:
      return BillingsOrderRailyTaxiCreateParamsBonusType.SHORT_ROUTE;
    default:
      return undefined;
  }
};

const createPenaltyType = (
  penaltyType: PenaltyType | undefined,
): BillingsOrderRailyTaxiCreateParamsPenaltyType | undefined => {
  switch (penaltyType) {
    case PenaltyType.BEING_LATE:
      return BillingsOrderRailyTaxiCreateParamsPenaltyType.BEING_LATE;
    case PenaltyType.GUIDELINE_IGNORED:
      return BillingsOrderRailyTaxiCreateParamsPenaltyType.GUIDELINE_IGNORED;
    case PenaltyType.HIGHWAY_NOT_ALLOWED:
      return BillingsOrderRailyTaxiCreateParamsPenaltyType.HIGHWAY_NOT_ALLOWED;
    case PenaltyType.INCOMPATIBLE_CAR:
      return BillingsOrderRailyTaxiCreateParamsPenaltyType.INCOMPATIBLE_CAR;
    case PenaltyType.OPTIMIZATION_REFUSED:
      return BillingsOrderRailyTaxiCreateParamsPenaltyType.OPTIMIZATION_REFUSED;
    case PenaltyType.OTHER:
      return BillingsOrderRailyTaxiCreateParamsPenaltyType.OTHER;
    case PenaltyType.SUBOPTIMAL_RIDE:
      return BillingsOrderRailyTaxiCreateParamsPenaltyType.SUBOPTIMAL_RIDE;
    default:
      return undefined;
  }
};

const createSaveBillingRequest = (
  orderUuid: string,
  data: BillingFormData,
): BillingsOrderRailyTaxiCreateParams => {
  const result: BillingsOrderRailyTaxiCreateParams = {
    orderUuid: orderUuid,
    billingNodes: createBillingNodes(data.billingNodes),
    bonus: data.bonus,
    bonusType: createBonusType(data.bonusType),
    penalty: data.penalty,
    penaltyType: createPenaltyType(data.penaltyType),
  };
  return result;
};

const billingSaveRequestFactory = {
  createSaveBillingRequest,
};

export default billingSaveRequestFactory;
